import axios from 'axios';
import { Base_URL } from './apiURL';
export async function scoringFetch(questionId, url, options) {
  const submissionId = window.sessionStorage.getItem(`swiftuni:pte-practice-submission:${questionId}`);
  if (!submissionId) throw new Error('Submit this answer again to check scoring access. Your answer is preserved.');
  const body = options.body;
  const payload = typeof body === 'string' ? {
    kind: 'json',
    body
  } : {
    kind: 'form',
    fields: Array.from(body.entries())
  };
  if (payload.kind === 'form' && payload.fields.some(pair => pair.some(value => typeof value !== 'string'))) throw new Error('Upload the recording before scoring.');
  const response = await axios.post(`${Base_URL}/app/users/scoring-permits/practice`, {
    questionId,
    submissionId,
    operation: new URL(url).pathname,
    payload
  }, {
    withCredentials: true
  });
  const grant = response.data?.response;
  if (response.data?.responseCode !== 200 || !grant) throw new Error(response.data?.message || 'Scoring permission could not be checked.');
  if (grant.status === 'completed') return new Response(JSON.stringify(grant.result), {
    status: grant.responseStatus,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (grant.status !== 'authorized' || !grant.permit) throw new Error('Scoring is not authorized. Your answer is preserved.');
  const headers = new Headers(options.headers);
  headers.set('X-Scoring-Permit', grant.permit);
  if (!grant.payload) throw new Error('Scoring content could not be verified. Your answer is preserved.');
  let prepared;
  if (grant.payload.kind === 'json') prepared = grant.payload.body;else {
    prepared = new FormData();
    for (const [key, value] of grant.payload.fields) prepared.append(key, value);
  }
  return fetch(url, {
    ...options,
    headers,
    body: prepared
  });
}
